"use client";

import { BookingProvider } from "@/context/BookingContext";
import { HotelProvider } from "@/context/HotelContext";
import { Suspense } from "react";

function Loading() {
  return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<Loading />}>
      <HotelProvider>
        <BookingProvider>{children}</BookingProvider>
      </HotelProvider>
    </Suspense>
  );
}
